import { DataFilter } from '@siclop/kstone-vue'

export class LeaveBalanceFilter extends DataFilter {
  employeeId?: number
  leaveTypeId?: number
  /** Année de début de la période (CP : 2026 = juin 2026 → mai 2027 ; RTT : année civile). */
  periodStartYear?: number
  /** `YYYY-MM-DD` : seulement les soldes non échus à cette date. */
  openAt?: string

  constructor(data?: Partial<LeaveBalanceFilter>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId
      this.leaveTypeId = data.leaveTypeId
      this.periodStartYear = data.periodStartYear
      this.openAt = data.openAt
    }
  }
}
